
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import {
    AppBar, Box, CssBaseline, Toolbar, IconButton, useMediaQuery
} from '@mui/material';
import { IconMenu2 } from '@tabler/icons';

import LogoSection from 'layout/MainLayout/LogoSection';
import ProfileSection from 'layout/MainLayout/Header/ProfileSection';
import HrSidebar, { HR_DRAWER_WIDTH } from './HrSidebar';

export default function HrLayout() {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const [drawerOpen, setDrawerOpen] = useState(true);

    const handleDrawerToggle = () => setDrawerOpen((p) => !p);

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f4f6fa' }}>
            <CssBaseline />

            {/* AppBar */}
            <AppBar
                position="fixed"
                elevation={2}
                sx={{
                    bgcolor: '#fff',
                    color: '#000',
                    zIndex: theme.zIndex.drawer + 1,
                    borderBottom: '1px solid #e0e0e0',
                }}
            >
                <Toolbar sx={{ minHeight: '64px !important', px: { xs: 2, sm: 3 } }}>
                    {/* Hamburger for sidebar */}
                    <IconButton
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 1, color: '#114CC2' }}
                        size="large"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </IconButton>

                    {/* Logo */}
                    <Box sx={{ width: 180, display: 'flex', alignItems: 'center' }}>
                        <LogoSection />
                    </Box>

                    <Box sx={{ flexGrow: 1 }} />

                    {/* Profile */}
                    <ProfileSection />
                </Toolbar>
            </AppBar>

            {/* HR-only Sidebar */}
            <HrSidebar drawerOpen={matchUpMd ? drawerOpen : !drawerOpen} drawerToggle={handleDrawerToggle} />

            {/* Main content — shifts right when sidebar is open */}
<Box
    component="main"
    sx={{
        flexGrow: 1,
        width: '100%',
        minWidth: 0,
        pt: '80px',
        px: { xs: 2, sm: 2.5, md: 3 },
        pb: 3,
        overflowX: 'hidden',
        transition: 'all 0.25s ease',
    }}
>
    <Outlet />
</Box>
        </Box>
    );
}